import { type ValueOf } from '@/lib/utils/type'

import { type CaseApplicationType, type CaseHistoryItem, type VisaBulletinIconType } from '../types'
import { type VISA_TYPE_MAP } from './constants'

export interface CaseSearchItemWithHistory extends CaseSearchItem {
  history: CaseHistoryItem[]
}
export interface CaseSearchItem {
  applicantName: string
  applicant_path_id: number
  applicationFiledDate: string | null // YYYY-MM-DD
  applicationType: CaseApplicationType
  assignee: number[]
  assigneeNames: string[]
  caseMessage: string
  caseStatus: string
  case_id: number
  case_number: string
  case_type: string
  dolInformation: DolInformation | null
  nvcInformation: NvcInformation | null
  inquirySubmitted: boolean
  isAvailableRequest: boolean
  isEligibleAOS: boolean | null
  isUpdated: boolean
  is_archive: boolean
  is_dol: boolean
  is_end: boolean
  is_invalid: boolean
  is_public: boolean
  isPremium: boolean
  path_id: number
  processingDays: number | null
  tags?: string[] | null
  user_id: number
  visaBulletin: {
    bulletinDate: string
    filingDate: string
    finalActionDate: string
    isEligibleAOS: boolean
    nextBulletinDate: string
    nextFilingDate: string
    nextFinalActionDate: string
    nextNoticeText: string
    nextUseField: string
    noticeText: string
    priorityDate: string
    useField: string
  }
  visaBulletinSubmitted: boolean
  visaBulletinV2: {
    current: VisaBulletinInformation
    next: VisaBulletinInformation
    priorityDate: string
  }
  updatedAt: string | null // YYYY-MM-DDTHH:mm:ssZ
  nextHearingDate: string | null // YYYY-MM-DDTHH:mm:ssZ
}

export interface DolInformation {
  employer_name: string
  job_title: string
  submitted_date: string // YYYY-MM-DD
}

export interface NvcInformation {
  location: string
  passportNumber: string
  surname: string
  visaType: VisaType
}

export interface VisaBulletinInformation {
  bulletinDate: string // The date of the visa bulletin
  bulletinIcon: VisaBulletinIconType
  bulletinText: string
  filingDate: string // The filing date or "current" if the visa is current or "unauthorized" if the visa is unauthorized
  finalActionDate: string //The final action date or "current" if the visa is current or "unauthorized" if the visa is unauthorized
  isEligibleAOS: boolean
  noticeText: string
  useField: string
}

export type VisaType = ValueOf<typeof VISA_TYPE_MAP>

/**
 * User roles and their corresponding permission levels.
 * - super admin: Have the same permissions as admin but this role cannot be removed by any user. Initial admin user get this role when signing up.
 * - admin: Can manage users except Super Admins
 * - user: Basic access level
 */
export const UserRole = {
  SUPER_ADMIN: 'super admin',
  ADMIN: 'admin',
  USER: 'user',
} as const
export type UserRole = ValueOf<typeof UserRole>
